//#region src/utils/guid.ts
var generateGUID = () => {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = Math.random() * 16 | 0;
		return (c === "x" ? r : r & 3 | 8).toString(16);
	});
};
//#endregion
export { generateGUID };

//# sourceMappingURL=guid.js.map